export const destinationCategories = [
  { id: 'all', name: '全部目的地', icon: 'ri-global-line' },
  { id: 'polar', name: '南北极', icon: 'ri-snowy-line' },
  { id: 'africa', name: '非洲', icon: 'ri-sun-line' },
  { id: 'island', name: '野奢海岛', icon: 'ri-ship-line' },
  { id: 'nordic', name: '北欧秘境', icon: 'ri-aurora-line' },
  { id: 'other', name: '其他目的地', icon: 'ri-map-2-line' },
];

export const themeFilters = [
  { id: 'all', name: '全部主题' },
  { id: 'polar', name: '极地探险' },
  { id: 'safari', name: '非洲Safari' },
  { id: 'island', name: '野奢海岛' },
  { id: 'cruise', name: '奢华邮轮' },
  { id: 'nordic', name: '北欧秘境' },
  { id: 'ecology', name: '生态研学' },
];

export const durationFilters = [
  { id: 'all', name: '全部天数' },
  { id: '7', name: '7天以内' },
  { id: '14', name: '7-14天' },
  { id: '21', name: '14天以上' },
];

export const seasonFilters = [
  { id: 'all', name: '全年可出发' },
  { id: 'spring', name: '春季（3-5月）' },
  { id: 'summer', name: '夏季（6-8月）' },
  { id: 'autumn', name: '秋季（9-11月）' },
  { id: 'winter', name: '冬季（12-2月）' },
];

export const budgetFilters = [
  { id: 'all', name: '全部预算' },
  { id: '50000', name: '5万以内' },
  { id: '100000', name: '5-10万' },
  { id: '200000', name: '10万以上' },
];

export interface Destination {
  id: string;
  name: string;
  englishName: string;
  category: string;
  categoryId: string;
  themeId: string;
  image: string;
  slogan: string;
  tags: string[];
  minPrice: string;
  duration: string;
  bestSeason: string;
  seasonId: string;
  budgetId: string;
  durationId: string;
  description: string;
  highlights: string[];
  visa: string;
  climate: string;
  currency: string;
  language: string;
  timezone: string;
  mustDo: string[];
  itineraries: {
    id: string;
    title: string;
    days: string;
    price: string;
    highlights: string[];
    image: string;
  }[];
  gallery: string[];
  reviews: {
    name: string;
    avatar: string;
    profession: string;
    rating: number;
    comment: string;
    date: string;
  }[];
  tips: string[];
  equipment: string[];
  // 新增 GEO 实体字段：均可在首屏初始 HTML 中直接出现，供搜索引擎稳定抓取
  travelerType?: string;
  whenToGo?: string;
  planningNotes?: string[];
  faq?: { question: string; answer: string }[];
  relatedLinks?: { label: string; path: string }[];
}

export const destinations: Destination[] = [
  {
    id: 'antarctica',
    name: '南极半岛',
    englishName: 'Antarctica Peninsula',
    category: '南北极',
    categoryId: 'polar',
    themeId: 'polar',
    image:
      'https://readdy.ai/api/search-image?query=Antarctica%20peninsula%20dramatic%20icebergs%20glaciers%20pristine%20white%20blue%20ice%20landscape%20penguin%20colonies%20dramatic%20sky%20expedition%20ship%20in%20distance%20ultra%20wide%20angle%20cinematic%20photography&width=800&height=560&seq=dest001&orientation=landscape',
    slogan: '踏上地球最后的净土，与企鹅为邻，在冰川之间感受生命的壮阔',
    tags: ['极地探险', '企鹅观察', '冰川徒步', '邮轮探险'],
    minPrice: '¥89,800',
    duration: '11-21天',
    bestSeason: '11月-次年3月',
    seasonId: 'summer',
    budgetId: '200000',
    durationId: '14',
    description:
      '南极半岛是地球上最后一片真正意义上的荒野，这里有壮观的冰川、成群的企鹅、海豹和鲸鱼。自由旷野旅行依托与海达路德、庞洛等顶级极地邮轮的长期合作，为您打造最专业、最安全的南极探险体验。',
    highlights: [
      '乘坐专业极地探险船深入南极半岛',
      '近距离观察帝企鹅、阿德利企鹅群落',
      '登陆南极大陆，踏上地球最南端的土地',
      '冰川皮划艇、雪地徒步等极限体验',
      '专业极地生物学家随船讲解',
    ],
    visa: '无需签证，持有效护照即可登船',
    climate: '夏季（11月-3月）气温-2°C至8°C，极昼现象，日照充足',
    currency: '美元（USD）',
    language: '英语为主，船上配备中文讲解',
    timezone: 'UTC-3',
    mustDo: [
      '企鹅栖息地登陆',
      '冰川皮划艇',
      '极地露营体验',
      '鲸鱼观察巡游',
      '南极科考站参观',
    ],
    itineraries: [
      {
        id: 'ant-01',
        title: '南极半岛经典探险',
        days: '11天9晚',
        price: '¥89,800起',
        highlights: [
          '乌斯怀亚出发',
          '德雷克海峡穿越',
          '南极半岛登陆5次',
          '企鹅群落近距离观察',
        ],
        image:
          'https://readdy.ai/api/search-image?query=Antarctica%20expedition%20zodiac%20boat%20approaching%20icebergs%20penguins%20on%20ice%20dramatic%20polar%20landscape%20blue%20sky%20reflection%20in%20calm%20water&width=600&height=400&seq=ant01&orientation=landscape',
      },
      {
        id: 'ant-02',
        title: '南极深度探险·南极圈穿越',
        days: '16天14晚',
        price: '¥128,800起',
        highlights: ['穿越南极圈', '南乔治亚岛', '福克兰群岛', '王企鹅栖息地'],
        image:
          'https://readdy.ai/api/search-image?query=Antarctica%20circle%20crossing%20expedition%20ship%20massive%20icebergs%20dramatic%20polar%20sunset%20orange%20sky%20reflection%20pristine%20wilderness&width=600&height=400&seq=ant02&orientation=landscape',
      },
      {
        id: 'ant-03',
        title: '南极摄影专属团',
        days: '14天12晚',
        price: '¥158,800起',
        highlights: [
          '专业摄影师带队',
          '最佳拍摄机位',
          '摄影工作坊',
          '独家登陆点',
        ],
        image:
          'https://readdy.ai/api/search-image?query=Antarctica%20photography%20expedition%20golden%20hour%20light%20penguins%20icebergs%20dramatic%20clouds%20professional%20wildlife%20photography%20pristine%20nature&width=600&height=400&seq=ant03&orientation=landscape',
      },
    ],
    gallery: [
      'https://readdy.ai/api/search-image?query=Antarctica%20massive%20tabular%20iceberg%20turquoise%20water%20dramatic%20blue%20sky%20pristine%20polar%20landscape%20expedition%20photography&width=800&height=600&seq=antg01&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Antarctica%20emperor%20penguins%20colony%20hundreds%20of%20penguins%20on%20ice%20dramatic%20polar%20landscape%20wildlife%20photography&width=800&height=600&seq=antg02&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Antarctica%20humpback%20whale%20breaching%20dramatic%20polar%20ocean%20icebergs%20background%20wildlife%20photography&width=800&height=600&seq=antg03&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Antarctica%20zodiac%20cruise%20among%20icebergs%20tourists%20expedition%20dramatic%20polar%20landscape%20adventure%20photography&width=800&height=600&seq=antg04&orientation=landscape',
    ],
    reviews: [],
    tips: [
      '提前3-6个月预订，热门船期极易售罄',
      '出发前需完成体检，确保身体状况适合极地探险',
      '防水外套、保暖内衣、防水靴是必备装备',
      '晕船药建议提前准备，德雷克海峡风浪较大',
      '相机建议携带防水袋，低温环境注意电池保暖',
    ],
    equipment: [
      '防水冲锋衣（建议-20°C以上）',
      '保暖内衣套装',
      '防水徒步靴',
      '太阳镜（防紫外线）',
      '防水手套',
      '保暖帽',
      '背包防水套',
      '相机防水袋',
    ],
  },
  {
    id: 'arctic',
    name: '北极',
    englishName: 'Arctic',
    category: '南北极',
    categoryId: 'polar',
    themeId: 'polar',
    image:
      'https://storage.readdy-site.link/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/531c9083-a146-4839-b1f5-204a462870e0_DSC02622-1.jpeg?v=d35b63f853e7dc8b2385eed4bf2edd51',
    slogan: '穿越浮冰与极光，探寻斯瓦尔巴、格陵兰与冰岛的极地荒野',
    tags: ['斯瓦尔巴', '格陵兰', '冰岛', '极地邮轮'],
    minPrice: '',
    duration: '8-15天',
    bestSeason: '受区域与冰况影响，需实时确认',
    seasonId: 'summer',
    budgetId: '200000',
    durationId: '14',
    description:
      '北极并非单一国家，通常指围绕斯瓦尔巴、格陵兰、冰岛等区域的极地旅行。邮轮航行与陆地旅行是两种主要方式，天气、冰况与野生动物观察均不可保证。自由旷野旅行结合区域与季节差异，提供一对一极地行程建议与航次参考。',
    highlights: [
      '斯瓦尔巴群岛极地邮轮与北极熊观察',
      '格陵兰冰峡湾与北极光',
      '冰岛火山与冰川地貌',
      '区分邮轮航行与陆地旅行的体验差异',
    ],
    visa: '不同区域入境要求不同，以官方及实际预订确认为准',
    climate: '受区域与季节影响显著，天气多变，冰况直接影响航线与活动',
    currency: '挪威克朗（NOK）、丹麦克朗（DKK）、冰岛克朗（ISK）等',
    language: '当地语言为主，邮轮及主要区域可提供英语服务',
    timezone: '因区域而异（UTC±0 至 UTC+1）',
    mustDo: [
      '斯瓦尔巴极地邮轮巡游',
      '格陵兰伊卢利萨特冰峡湾',
      '冰岛黄金圈与冰川徒步',
      '北极光追逐',
    ],
    itineraries: [],
    gallery: [],
    reviews: [],
    tips: [],
    equipment: [],
    travelerType:
      '适合希望探索极地荒野、对邮轮航行或陆地极地旅行感兴趣的旅行者。不同区域与方式对体能、预算和适应能力的要求差异较大，需结合个人情况选择。',
    whenToGo:
      '北极各区域的可旅行季节差异明显，且受天气、海冰与航线安排影响较大。斯瓦尔巴的极地邮轮季、格陵兰的观冰与北极光季、冰岛的全年地貌体验各有不同，具体航次与出行时间需结合船司公布信息与当年情况确认，不保证特定野生动物观察。',
    planningNotes: [
      '极地邮轮航次数量有限，建议提前较长时间规划并确认余位',
      '北极天气多变，行程可能因冰况与安全因素调整',
      '斯瓦尔巴、格陵兰、冰岛的签证与行程安排要求不同，需逐项核实',
      '野生动物观察属自然现象，无法保证特定物种出现',
    ],
    faq: [
      {
        question: '北极是哪个国家？',
        answer: '北极不是单一国家，而是指北极圈附近的区域，通常包括挪威斯瓦尔巴群岛、丹麦格陵兰岛、冰岛等。自由旷野旅行的北极行程会围绕这些区域及邮轮航线进行设计。',
      },
      {
        question: '北极旅行该选邮轮还是陆地？',
        answer: '邮轮航行适合深入斯瓦尔巴等海域、连续探索多个登陆点；陆地旅行则更适合聚焦格陵兰或冰岛的深度体验。两者对时间、预算和体能的要求不同，建议结合个人偏好与出行季节咨询旅行顾问。',
      },
      {
        question: '去北极一定能看到北极熊吗？',
        answer: '北极熊是野生动物，其活动受季节、冰况和食物分布影响，无法保证一定能观察到。我们会选择北极熊出现概率较高的区域与季节，但不做必然承诺。',
      },
    ],
    relatedLinks: [
      { label: '南北极旅行', path: '/polar' },
      { label: '极地航次查询', path: '/polar-finder' },
      { label: '极地百科', path: '/wiki/polar' },
    ],
  },
  {
    id: 'tanzania',
    name: '坦桑尼亚',
    englishName: 'Tanzania',
    category: '非洲',
    categoryId: 'africa',
    themeId: 'safari',
    image:
      'https://readdy.ai/api/search-image?query=Tanzania%20Serengeti%20great%20migration%20wildebeest%20crossing%20Mara%20river%20dramatic%20golden%20sunset%20African%20savanna%20wildlife%20photography%20cinematic&width=800&height=560&seq=dest002&orientation=landscape',
    slogan: '见证地球上最壮观的动物大迁徙，在塞伦盖蒂感受生命的轮回',
    tags: ['动物大迁徙', '野奢营地', 'Safari游猎', '乞力马扎罗'],
    minPrice: '¥68,800',
    duration: '8-14天',
    bestSeason: '6月-10月',
    seasonId: 'summer',
    budgetId: '100000',
    durationId: '14',
    description:
      '坦桑尼亚是非洲Safari的圣地，拥有塞伦盖蒂国家公园、恩戈罗恩戈罗火山口、乞力马扎罗山等世界级自然奇观。每年6-10月的动物大迁徙是地球上最壮观的自然景观之一，数百万角马、斑马横渡马拉河的震撼场面令人终生难忘。',
    highlights: [
      '塞伦盖蒂动物大迁徙全程追踪',
      '恩戈罗恩戈罗火山口游猎',
      '顶级野奢营地入住体验',
      '热气球Safari俯瞰大草原',
      '马赛族文化深度体验',
    ],
    visa: '落地签或电子签，费用约50美元',
    climate: '旱季（6-10月）最佳，气温20-30°C，动物集中',
    currency: '坦桑尼亚先令（TZS），美元通用',
    language: '斯瓦希里语、英语',
    timezone: 'UTC+3',
    mustDo: [
      '塞伦盖蒂大迁徙追踪',
      '热气球Safari',
      '恩戈罗恩戈罗火山口游猎',
      '马赛族村落体验',
      '桑给巴尔岛休闲',
    ],
    itineraries: [],
    gallery: [
      'https://readdy.ai/api/search-image?query=Tanzania%20Serengeti%20wildebeest%20great%20migration%20thousands%20animals%20crossing%20river%20dramatic%20wildlife%20photography%20golden%20light&width=800&height=600&seq=tang01&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Tanzania%20lion%20pride%20resting%20acacia%20tree%20golden%20sunset%20African%20savanna%20wildlife%20photography&width=800&height=600&seq=tang02&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Tanzania%20luxury%20safari%20camp%20tent%20interior%20elegant%20design%20African%20wilderness%20view%20from%20tent&width=800&height=600&seq=tang03&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Tanzania%20hot%20air%20balloon%20safari%20sunrise%20Serengeti%20plains%20animals%20below%20dramatic%20sky&width=800&height=600&seq=tang04&orientation=landscape',
    ],
    reviews: [],
    tips: [
      '大迁徙最佳观赏期为7-9月，提前半年预订',
      '疫苗接种：黄热病疫苗（部分地区必须），疟疾预防药物',
      'Safari着装建议卡其色、棕色等大地色系，避免鲜艳颜色',
      '相机建议携带长焦镜头（400mm以上），野生动物拍摄必备',
      '旱季（6-10月）最佳，雨季道路泥泞影响游猎体验',
    ],
    equipment: [
      '轻便卡其色Safari服装',
      '防晒霜（SPF50+）',
      '长焦相机镜头',
      '双筒望远镜',
      '防虫喷雾',
      '宽檐遮阳帽',
      '轻便徒步鞋',
    ],
  },
  {
    id: 'botswana',
    name: '博茨瓦纳',
    englishName: 'Botswana',
    category: '非洲',
    categoryId: 'africa',
    themeId: 'safari',
    image:
      'https://storage.readdy-site.link/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/35606dbc-4adc-4022-bd1d-2e5b54f60c59_Wilderness-DumaTau.jpg?v=dd5a9987586d57bdae03942b7a478c4a',
    slogan: '水陆双栖的野奢 Safari 天堂，在奥卡万戈三角洲聆听荒野的呼吸',
    tags: ['水陆游猎', '奥卡万戈三角洲', '野奢营地', '小飞机接驳'],
    minPrice: '',
    duration: '6-12天',
    bestSeason: '受水位与季节影响，需实时确认',
    seasonId: 'summer',
    budgetId: '200000',
    durationId: '14',
    description:
      '博茨瓦纳是非洲高端 Safari 的代表目的地之一，以奥卡万戈三角洲的水陆游猎与乔贝、林阳蒂等区域的陆地游猎著称。这里动物密度较高、游客密度相对较低，适合追求私密与深度的旅行者。不同区域的季节与水位差异明显，行程安排需结合实际情况，自由旷野旅行提供一对一方案设计。',
    highlights: [
      '奥卡万戈三角洲水陆游猎（莫科罗独木舟与船游）',
      '乔贝国家公园大象群观察',
      '林阳蒂与萨武蒂陆地驱车游猎',
      '轻型小飞机接驳野奢营地',
      '低密度、高私密性的荒野体验',
    ],
    visa: '入境要求以官方及实际预订确认为准',
    climate: '旱季与水季差异明显，奥卡万戈三角洲水位随季节波动',
    currency: '博茨瓦纳普拉（BWP），美元通用',
    language: '英语、茨瓦纳语',
    timezone: 'UTC+2',
    mustDo: [
      '莫科罗独木舟穿越三角洲水道',
      '乔贝国家公园大象群游猎',
      '水上观光与陆地驱车组合',
      '荒野野奢营地入住体验',
    ],
    itineraries: [],
    gallery: [],
    reviews: [],
    tips: [],
    equipment: [],
    travelerType:
      '适合偏好私密、低密度与深度自然体验的旅行者，包括摄影爱好者、蜜月及纪念旅行、以及希望兼顾水陆两种 Safari 方式的家庭与资深旅行者。',
    whenToGo:
      '博茨瓦纳不同区域的旱季与水季差异明显，奥卡万戈三角洲水位随季节波动，直接影响可开展的水上活动。具体出行时间与可参与活动需结合当年水位与营地开放情况实时确认，不承诺全年均可体验同一活动组合。',
    planningNotes: [
      '行程通常需要轻型小飞机接驳，行李有重量限制',
      '水陆活动组合取决于季节与水位，需提前确认可参与项目',
      '热门野奢营地在旺季房态紧张，建议提前较长时间预订',
      '动物观察受自然条件影响，不承诺必看特定物种',
    ],
    faq: [
      {
        question: '博茨瓦纳和东非 Safari 有什么不同？',
        answer: '博茨瓦纳以奥卡万戈三角洲的水陆游猎、低密度营地和私密体验见长，游客密度相对较低；东非则以经典草原驱车游猎和大迁徙观察为主。两者在生态、活动方式与节奏上差异明显，适合不同偏好的旅行者。',
      },
      {
        question: '去博茨瓦纳一定要坐小飞机吗？',
        answer: '博茨瓦纳的野奢营地多分布在偏远荒野，通常需要轻型小飞机接驳，行李重量也有限制。是否必须乘坐取决于具体营地区域，建议在方案设计阶段确认。',
      },
      {
        question: '奥卡万戈三角洲什么时候去最合适？',
        answer: '三角洲的水位随季节波动，旱季与水季可开展的水上活动不同，并没有一个全年通用的"最佳时间"。出行时间需结合当年水位与想体验的活动类型实时确认。',
      },
    ],
    relatedLinks: [
      { label: '真实旅途回声（博茨瓦纳客户记录）', path: '/customer-stories' },
      { label: '博茨瓦纳百科', path: '/wiki/africa/botswana-2026' },
      { label: '创始人博茨瓦纳实地调研', path: '/wiki/brand/founder-africa-luxury-scouting-2026' },
    ],
  },
  {
    id: 'kenya',
    name: '肯尼亚',
    englishName: 'Kenya',
    category: '非洲',
    categoryId: 'africa',
    themeId: 'safari',
    image:
      'https://storage.readdy-site.link/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/edbe8565-ebf2-426d-8663-4e0d3912d7ae_7.jpg?v=275d12dbd9c2c7191b17f458bb800e4b',
    slogan: '经典 Safari 的起源地，在马赛马拉与安博塞利读懂东非草原',
    tags: ['马赛马拉', '动物迁徙', '肯坦联游', '经典Safari'],
    minPrice: '',
    duration: '7-12天',
    bestSeason: '受迁徙时间与自然条件影响，需实时确认',
    seasonId: 'summer',
    budgetId: '100000',
    durationId: '14',
    description:
      '肯尼亚是经典 Safari 的起源地之一，马赛马拉、安博塞利与莱基皮亚等区域提供差异化的草原与野生动物体验。动物迁徙与渡河属于自然现象，具体时间受自然条件影响，无法保证固定的观察结果。自由旷野旅行结合出行季节与个人偏好，提供肯尼亚单国或肯坦联游的一对一方案。',
    highlights: [
      '马赛马拉草原与迁徙季观察',
      '安博塞利与乞力马扎罗山景观',
      '莱基皮亚私属保护区的低密度体验',
      '马赛文化接触',
      '肯尼亚与坦桑尼亚跨境联游',
    ],
    visa: '入境要求以官方及实际预订确认为准',
    climate: '旱季与雨季分明，保护区动物观察受季节与降雨影响',
    currency: '肯尼亚先令（KES），美元通用',
    language: '英语、斯瓦希里语',
    timezone: 'UTC+3',
    mustDo: [
      '马赛马拉驱车游猎',
      '安博塞利观察象群与乞力马扎罗景观',
      '莱基皮亚私属保护区体验',
      '马赛部落文化接触',
    ],
    itineraries: [],
    gallery: [],
    reviews: [],
    tips: [],
    equipment: [],
    travelerType:
      '适合首次体验 Safari、家庭出行、摄影爱好者，以及希望以相对成熟的路线进入东非野生动物体验的旅行者。',
    whenToGo:
      '动物迁徙与渡河属于自然现象，发生时间每年存在波动，不保证在特定日期看到渡河。不同保护区的最佳观察时间各异，出行时间需结合当年情况与个人观察目标确认。',
    planningNotes: [
      '迁徙季热门区域房态紧张，建议提前规划',
      '肯坦跨境需留意签证与口岸安排',
      '保护区用车与活动规则以实际预订为准',
      '动物观察受自然条件影响，不使用"保证看到"等表述',
    ],
    faq: [
      {
        question: '马赛马拉和塞伦盖蒂怎么选？',
        answer: '马赛马拉与塞伦盖蒂同属东非大迁徙生态体系，但分属肯尼亚与坦桑尼亚，在保护区范围、营地分布和线路节奏上有所不同。选择哪个取决于出行月份、想看的场景和跨境安排，建议结合具体时间咨询旅行顾问。',
      },
      {
        question: '动物大迁徙的渡河时间能保证看到吗？',
        answer: '迁徙与渡河是野生动物自然行为，受降雨和草原条件影响，时间每年都有波动，无法保证在特定日期看到渡河。我们会根据当年信息设计更合理的观察窗口，但不做必然承诺。',
      },
      {
        question: '肯尼亚适合第一次去非洲 Safari 吗？',
        answer: '肯尼亚拥有相对成熟的 Safari 基础设施和丰富的野生动物资源，是很多旅行者首次进入东非的选择之一。适合与否仍取决于出行时间、预算和个人偏好，可与顾问沟通后确定。',
      },
    ],
    relatedLinks: [
      { label: '肯尼亚与坦桑尼亚联游套餐', path: '/safari-packages/east-africa/2026-andbeyond-safari' },
      { label: '肯尼亚 vs 坦桑尼亚迁徙对比', path: '/wiki/africa/migration-kenya-vs-tanzania' },
      { label: '非洲最佳旅行时间', path: '/wiki/africa/africa-best-time-2026' },
    ],
  },
  {
    id: 'rwanda',
    name: '卢旺达',
    englishName: 'Rwanda',
    category: '非洲',
    categoryId: 'africa',
    themeId: 'safari',
    image:
      'https://storage.helloreaddy.io/project_files/8a4257b0-b93a-4ea5-a25c-adeacbcec648/1270d8b6-0a5b-417e-971e-15d360797a6c_compressed_fw-founder-07-2026-rwanda-gorilla-fieldwork.webp',
    slogan: '在山地森林中追踪大猩猩，体验东非自然旅行的另一种深度',
    tags: ['山地大猩猩追踪', '火山国家公园', '雨林体验', '东非联游'],
    minPrice: '',
    duration: '5-10天',
    bestSeason: '受徒步条件与天气影响，需实时确认',
    seasonId: 'all',
    budgetId: '200000',
    durationId: '7',
    description:
      '卢旺达以火山国家公园的山地大猩猩追踪为核心，结合阿卡盖拉草原与雨林类体验，是东非自然旅行的另一维度。大猩猩追踪的许可、年龄与健康要求、现场规则均以官方及实际预订确认为准。自由旷野旅行提供卢旺达单国或与东非 Safari 联游的一对一方案。',
    highlights: [
      '火山国家公园山地大猩猩追踪',
      '阿卡盖拉国家公园草原游猎',
      '纽恩威森林雨林体验',
      '基伍湖休闲',
      '基加利城市衔接',
    ],
    visa: '入境要求以官方及实际预订确认为准',
    climate: '山地与雨林区域气候湿润多变，徒步条件受天气影响',
    currency: '卢旺达法郎（RWF），美元通用',
    language: '英语、法语、卢旺达语',
    timezone: 'UTC+2',
    mustDo: [
      '山地大猩猩追踪',
      '阿卡盖拉草原游猎',
      '纽恩威雨林徒步',
      '基伍湖湖畔休闲',
    ],
    itineraries: [],
    gallery: [],
    reviews: [],
    tips: [],
    equipment: [],
    travelerType:
      '适合希望深度观察山地大猩猩、偏好山地森林与雨林体验、以及计划将卢旺达与东非 Safari 联游的旅行者。',
    whenToGo:
      '山地大猩猩追踪全年开展，但徒步条件受天气与森林环境影响；追踪许可数量有限，需提前较长时间确认。具体出行时间建议结合许可可得性与个人安排确认。',
    planningNotes: [
      '大猩猩追踪许可需提前预订，数量有限',
      '追踪徒步有一定强度，对年龄与健康有要求',
      '追踪结果受大猩猩当日活动位置影响，不保证近距离观察',
      '现场规则以国家公园官方要求及实际预订确认为准',
    ],
    faq: [
      {
        question: '卢旺达山地大猩猩追踪许可怎么预订？',
        answer: '大猩猩追踪许可由卢旺达相关管理部门发放，数量有限，通常需要提前较长时间预订。自由旷野旅行会协助核实许可可得性与预订安排，具体规则与费用以官方及实际预订确认为准。',
      },
      {
        question: '大猩猩追踪对年龄和健康有要求吗？',
        answer: '追踪需要徒步进入山地森林，对体能和健康有一定要求，并可能存在年龄限制。具体要求以国家公园官方规定及实际预订确认为准，建议出行前与顾问逐项核实。',
      },
      {
        question: '卢旺达可以和东非 Safari 联游吗？',
        answer: '可以。卢旺达的大猩猩追踪与坦桑尼亚、肯尼亚的草原 Safari 属于不同体验，可组合成多国联游行程。具体线路与交通衔接需结合实际出行时间设计。',
      },
    ],
    relatedLinks: [
      { label: '真实旅途回声（卢旺达·博茨瓦纳记录）', path: '/customer-stories' },
      { label: '创始人卢旺达实地足迹', path: '/wiki/brand/founder-field-notes' },
      { label: '卢旺达 vs 乌干达大猩猩追踪', path: '/wiki/africa/rwanda-vs-uganda-gorilla-trekking' },
    ],
  },
];